import { api } from '@/services/api/main/axios';

export const getCurrenciesApiRequest = async () => {
  const res = await api.get('currencies');
  return res.data.payload;
};

export interface CurrencyExchangeRate {
  fromCurrency: string;
  rate: number;
  toCurrency: string;
}

export const getExchangeRatesApiRequest = async (baseCurrency?: string | null) => {
  const res = await api.get('currencies/exchange-rates', {
    params: baseCurrency ? { base_currency: baseCurrency } : undefined,
  });
  return res.data.payload as CurrencyExchangeRate[];
};
